import { withCollapse } from "common/layouts/ThreePanelLayout/ThreePanelCollapseContext";
import { POIv3 } from "common/Map/POI";
import { MapV2 } from "common/MapV2";
import { TrackLine } from "common/MapV2/TrackLine";
import React from "react";

class _CollapseMap extends React.PureComponent {
  render() {
    const { collapse, showSurface, troute, troutePhotos, troutePOIs } = this.props;
    // this component doesn't do anything unless we're in mobile collapse mode
    if (!collapse) {
      return null;
    }
    return (
      <MapV2 style={{ position: "relative", height: "35vh" }} initialViewport={{ bounds: troute.boundingBox }}>
        <TrackLine showSurface={showSurface} trackPoints={troute.trackPoints} objectId={troute.id} />
        {troutePOIs && troutePOIs.map((poi) => <POIv3 key={poi.id} poi={poi} photos={troutePhotos} />)}
      </MapV2>
    );
  }
}

export const CollapseMap = withCollapse(_CollapseMap);
